export const servicesTranslations = {
    // General Services Translations
    services_screen_title: "خدمات الاختبار",
    services_screen_description: "حلول ضمان الجودة الشاملة لضمان تفوق برمجياتك على التوقعات.",
    services_consult_button: "طلب استشارة",
    services_learnMore: "اقرأ المزيد",
    services_screen_discussProject: "دعنا نناقش مشروعك",
    services_screen_contactDescription: "اتصل بنا لتتعرف على كيف يمكن لكواليتي نكسس مساعدتك في ضمان جودة منتجاتك البرمجية.",
    
    // Services Details Screen
    service_details_ourProcess: "الطريقة التي نعمل بها",
    service_details_whatWeDoBest: "أفضل ما نقدمه",
    service_details_readyToStart: "مستعدون للبدء؟",
    service_details_contactUs: "اتصل بنا لمعرفة كيف يمكن لـ Quality Nexus مساعدتك في",
    service_details_needs: "احتياجاتك.",
    service_details_getInTouch: "تواصل معنا",
    services_labels: {
      basic: "أساسي",
      advanced: "متقدم",
      premium: "متميز"

    },
     // Contact Form - Services Screen
    services_contact_title: "لنتحدث عن مشروعك",
    services_contact_description: "اتصل بنا لمعرفة كيف يمكن لـ Quality Nexus أن تساعد في ضمان جودة منتجاتك البرمجية.",
        services_contact_form: {
        full_name_label: "الاسم الكامل",
        full_name_placeholder: "اسمك",
        email_label: "البريد الإلكتروني",
        email_placeholder: "your.email@example.com",
        company_label: "اسم شركتك",
        company_placeholder: "ما هو اسم شركتك؟",
        services_label: "الخدمة المطلوبة",
        services_placeholder: "اختر نوع الخدمة",
        message_label: "الرسالة",
        message_placeholder: "أخبرنا عن مشروعك واحتياجاتك للاختبار",
        submit_button: "إرسال الطلب",
        loading: "جارٍ الإرسال...",
        slack_message_intro: "تم تقديم طلب استفسار عن خدمة جديدة."
    },
    // shown message 
    form_submit_success: "تم إرسال رسالتك بنجاح.",
    form_submit_error: "حدث خطأ ما. حاول مرة أخرى لاحقًا.",
    // Crowd Sourced Testing coming soon
    coming_soon: "قريباً",  
    crowd_testing_coming_soon_description: "نحن نطور خدمات اختبار الحشود الشاملة. ترقبوا التحديثات!"  

}